type EventCallback = (event: PointerEvent) => void;

class GlobalEventManager {
  private pointerDownCallbacks: EventCallback[] = [];

  private pointerMoveCallbacks: EventCallback[] = [];

  private pointerUpCallbacks: EventCallback[] = [];

  constructor() {
    window.addEventListener("pointerdown", this.handlePointerDown);
    window.addEventListener("pointermove", this.handlePointerMove);
    window.addEventListener("pointerup", this.handlePointerUp);
  }

  // Register a component's event handlers
  registerPointerDown(callback: EventCallback) {
    this.pointerDownCallbacks.push(callback);
  }

  registerPointerMove(callback: EventCallback) {
    this.pointerMoveCallbacks.push(callback);
  }

  registerPointerUp(callback: EventCallback) {
    this.pointerUpCallbacks.push(callback);
  }

  // Unregister event handlers (when the component is unmounted or dragging stops)
  unregisterPointerDown(callback: EventCallback) {
    this.pointerDownCallbacks = this.pointerDownCallbacks.filter(
      (cb) => cb !== callback,
    );
  }

  unregisterPointerMove(callback: EventCallback) {
    this.pointerMoveCallbacks = this.pointerMoveCallbacks.filter(
      (cb) => cb !== callback,
    );
  }

  unregisterPointerUp(callback: EventCallback) {
    this.pointerUpCallbacks = this.pointerUpCallbacks.filter(
      (cb) => cb !== callback,
    );
  }

  private handlePointerDown = (event: PointerEvent) => {
    this.pointerDownCallbacks.forEach((callback) => callback(event));
  };

  private handlePointerMove = (event: PointerEvent) => {
    this.pointerMoveCallbacks.forEach((callback) => callback(event));
  };

  private handlePointerUp = (event: PointerEvent) => {
    this.pointerUpCallbacks.forEach((callback) => callback(event));
  };
}

// Singleton instance
const globalEventManager = new GlobalEventManager();
export default globalEventManager;
